// Load polyfills if needed

const modernBrowser = ( 'fetch' in window && 'assign' in Object );
if( !modernBrowser ) {
	const scriptElement = document.createElement('script');
	scriptElement.async = false;
	scriptElement.src = '../../assets/js/polyfills.bundle.js';
	document.head.appendChild(scriptElement);
	console.info('loaded polyfills');
}

require('es6-promise').polyfill();

import $ from 'jquery';
import _ from 'lodash';

// Implement pascal case
_.mixin({ 'pascalCase': _.flow(_.camelCase, _.upperFirst) });

import SVG from 'svg.js';

window.$ = window.jQuery = $;
window._ = _;
window.svgjs = SVG;

import 'bootstrap';
import 'svgxuse';
import 'slick-carousel';
import 'bootstrap-select/dist/js/bootstrap-select.min';

import inlineSVG from 'inline-svg';

inlineSVG.init({
	svgSelector: 'img.svg',
	initClass: 'js-inlinesvg'
});

import 'bootstrap-slider/dist/bootstrap-slider.min.js';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
import 'jquery-serializejson';

// https://github.com/aFarkas/lazysizes
import lazySizes from 'lazysizes';
import unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import bgset from 'lazysizes/plugins/bgset/ls.bgset';

lazySizes.cfg.preloadAfterLoad = true;
lazySizes.cfg.loadHidden = true;
lazySizes.cfg.loadMode = 3;

// $(document).on('lazybeforeunveil lazyloaded', function(e) {
// 	if(e.type === 'lazyloaded') {
// 		if($(e.target).parent().hasClass('lazyload-parent')) {
// 			$(e.target).parent().removeClass('lazyloading').addClass('lazyloaded');
// 		}
// 	}
//  else {
// 	if($(e.target).parent().hasClass('lazyload-parent')) {
// 		$(e.target).parent().addClass('lazyloading');
// 	}
// 	}
// });

// https://greensock.com/gsap/
import { gsap } from 'gsap/dist/gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// Objectfit polyfill - https://github.com/constancecchen/object-fit-polyfill#:~:text=A%20polyfill%20for%20browsers%20that,size%20is%20to%20background%2Dimage%20.
import 'objectFitPolyfill';
window.objectFitPolyfill();

 // Swiper JS - https://swiperjs.com/get-started
 import Swiper from 'swiper/swiper-bundle.js';

 // Lity - https://github.com/jsor/lity
 import lity from 'lity/dist/lity.js';

 lity.handlers('video', function(target) {
	if(typeof target === 'string' && target.indexOf('.mp4') > 0) {
		let html = '<div class="lity-iframe-container"><video autoplay playsinline controls>';
		html += '<source src="' + target + '" type="video/mp4">';
		html += '</video></div>';
		return html;
	}
	return false;
});

import Cookies from 'js-cookie';
